
/**
 * Module dependencies.
 */

import { breakpoints } from 'react-components/styles';
import { useMediaQuery } from '../media-query';

/**
 * `Breakpoint` type.
 */

type Breakpoint = keyof typeof breakpoints;

/**
 * `Type` type.
 */

type Type = 'min' | 'max';

/**
 * Get breakpoint value.
 */

function getBreakpointValue(breakpoint: Breakpoint, type: Type): number {
  const value = breakpoints[breakpoint];

  return type === 'max' ? value - 1 : value;
}

/**
 * Export `useBreakpoint` hook.
 */

export function useBreakpoint(breakpoint: Breakpoint, type: Type): boolean {
  const breakpointValue = getBreakpointValue(breakpoint, type);
  const query = `(${type}-width: ${breakpointValue}px)`;

  return useMediaQuery(query);
}
